import { render } from "./Ignition.vue?vue&type=template&id=35c33c07&scoped=true&ts=true"
import script from "./Ignition.vue?vue&type=script&lang=ts"
export * from "./Ignition.vue?vue&type=script&lang=ts"

import "./Ignition.vue?vue&type=style&index=0&id=35c33c07&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c33c07"]])

export default __exports__